import { render, staticRenderFns } from "./DiagnosisIndex.vue?vue&type=template&id=7d4a2a4e&"
import script from "./DiagnosisIndex.vue?vue&type=script&lang=js&"
export * from "./DiagnosisIndex.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosisIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports